/* eslint-disable unused-imports/no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import type { ReportsService as IReportsService } from '@cdab/scania/qpr/interactor'
import type { DOSAuditReportData } from '@cdab/scania/qpr/schema'
import type { AxiosResponse } from 'axios'

export class ReportsService implements IReportsService {
  private readonly mockDelayMS: number

  public constructor(mockDelayMS: number) {
    this.mockDelayMS = mockDelayMS
  }
  public GetAreaReport = async (areaIds: number[]): Promise<AxiosResponse> => {
    throw new Error('Not implemented')
  }

  public GetMarketSummaryReport = async (
    marketIds: number[],
    areaIds: number[]
  ): Promise<AxiosResponse> => {
    throw new Error('Not implemented')
  }

  public GetMarketDevioationsReport = async (
    marketIds: number[],
    dateFrom: string,
    dateTo: string
  ): Promise<AxiosResponse> => {
    throw new Error('Not implemented')
  }

  public GetEmptyDOSReport = async (
    dosVersion: number,
    dealerId: number,
    viewSummary: boolean,
    viewCheckpoints: boolean,
    viewPerspectives: boolean
  ): Promise<AxiosResponse> => {
    throw new Error('Not implemented')
  }

  public GetDOSReport = async (
    auditId: number,
    viewSummary: boolean,
    viewCheckpoints: boolean,
    viewPerspectives: boolean,
    viewDeviations: boolean,
    viewNotes: boolean
  ): Promise<AxiosResponse> => {
    throw new Error('Not implemented')
  }

  public GetStatisticsReport = async (
    startDate: string,
    endDate: string,
    dosVersion: number
  ): Promise<AxiosResponse> => {
    // Mock implementation - return empty Excel file buffer
    const mockExcelBuffer = new ArrayBuffer(8)
    return {
      data: mockExcelBuffer,
      status: 200,
      statusText: 'OK',
      headers: {
        'content-type':
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      },
      config: {}
    } as AxiosResponse
  }

  public GetDOSReportData = async (
    auditId: number
  ): Promise<DOSAuditReportData> => {
    throw new Error('Not implemented')
  }
}
